'use client';

import { useId, useRef, useState } from 'react';
import styles from './PlatformOmnichannelHero.module.scss';

export default function PlatformOmnichannelHero({ channels, label, platformLabel }) {
  const [active, setActive] = useState(0);
  const id = useId();
  const tabs = useRef([]);

  function handleKeyDown(event, index) {
    let next;
    if (event.key === 'ArrowRight' || event.key === 'ArrowDown') next = (index + 1) % channels.length;
    else if (event.key === 'ArrowLeft' || event.key === 'ArrowUp') next = (index + channels.length - 1) % channels.length;
    else if (event.key === 'Home') next = 0;
    else if (event.key === 'End') next = channels.length - 1;
    else return;
    event.preventDefault();
    setActive(next);
    tabs.current[next]?.focus();
  }

  return <div className={styles.hero}>
    <div className={styles.stage}>
      <div className={styles.photo}>
        <img src="/brand/customer-clean-v2.webp"
          srcSet="/optimized/images/customer-clean-v2-400-05fafff8be.webp 400w, /optimized/images/customer-clean-v2-800-bb8fb3e5cb.webp 800w, /optimized/images/customer-clean-v2-1200-ec58df438f.webp 1200w"
          sizes="(max-width: 800px) calc(100vw - 48px), 560px"
          width={1254} height={1254} alt="" loading="eager" fetchPriority="high" decoding="async" />
      </div>
      <div className={styles.questions} role="tablist" aria-label={label}>
        {channels.map((channel, index) => <button key={channel.id}
          ref={element => { tabs.current[index] = element; }} type="button" role="tab"
          id={`${id}-${channel.id}-tab`} aria-controls={`${id}-${channel.id}-panel`}
          aria-selected={active === index} tabIndex={active === index ? 0 : -1}
          className={`${styles.question} ${styles[channel.id]}`}
          onClick={() => setActive(index)} onKeyDown={event => handleKeyDown(event, index)}>
          <span className={styles.channel}><img src={channel.icon} width={22} height={22} alt="" />{channel.label}<span className={styles.dot} aria-hidden="true" /></span>
          <span className={styles.questionText}>{channel.question}</span>
        </button>)}
      </div>
    </div>
    <div className={styles.response}>
      <div className={styles.brand}><img src="/icon.svg" width={31} height={31} alt="" /><b>Palmate</b><span>{platformLabel}</span></div>
      <div className={styles.panels}>
        {channels.map((channel, index) => <div key={channel.id} role="tabpanel"
          id={`${id}-${channel.id}-panel`} aria-labelledby={`${id}-${channel.id}-tab`}
          aria-hidden={active !== index} tabIndex={active === index ? 0 : -1}
          className={styles.panel} data-active={active === index}>
          <p>{channel.answer}</p>
          <span className={styles.result}><svg width="16" height="16" viewBox="0 0 20 20" fill="none" aria-hidden="true"><path d="m4 10 4 4 8-8" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" /></svg>{channel.result}</span>
        </div>)}
      </div>
    </div>
  </div>;
}
